import React from 'react';
import Loader from 'src/shared/components/loader/Loader';
import PageNotFound from 'src/shared/components/page-not-found/PageNotFound';
import { ProductKey } from 'src/shared/types/engine/products';
import { ProductAccess } from 'src/shared/types/productLicensing';
import { GatedProductContext } from './GatedProductContext';

type AccessGateProps = {
    product: ProductKey;
    /** The access the caller already has, for a route that cannot use `ProductGate`. */
    access: ProductAccess;
    children: React.ReactNode;
};

/**
 * Shows a product page only when the access allows it: a loader until the
 * access is known, so a hidden page never shows for a moment, and
 * page-not-found when the product is hidden.
 *
 * Like `ProductGate`, it tells the page which product it is gated for, so
 * `StandardAppLayout` shows internal staff the visibility notice.
 */
const AccessGate = ({ product, access, children }: AccessGateProps) => {
    if (access === ProductAccess.LOADING) {
        return <Loader />;
    } else if (access === ProductAccess.HIDDEN) {
        return <PageNotFound />;
    } else {
        return <GatedProductContext.Provider value={product}>{children}</GatedProductContext.Provider>;
    }
};

export default AccessGate;
